module.exports = __webpack_public_path__ + "img/2026-05-03c_2.a2d88528.jpg";